import React, {FC} from 'react';
import styled from 'styled-components';

import {hoverSelector} from '../../../../libs/shared/helpers/src/browser/hoverHelpers';

/*
 * Props.
 */

interface AvatarHoverProps {
  isDarker?: boolean;
}

/*
 * Style.
 */

const StyledHoverDiv = styled.div<{$isDarker: boolean}>`
  position: absolute;
  top: 0;
  width: 0;
  width: 100%;
  height: 100%;

  border-radius: 50%;
  background-color: ${(p) => (p.$isDarker ? p.theme.avatar.backgroundHover : p.theme.avatar.background)};
  opacity: 0;

  ${hoverSelector} {
    opacity: 1;
  }
`;

/*
 * Component.
 */

export const AvatarHover: FC<AvatarHoverProps> = ({isDarker}) => (
  <StyledHoverDiv $isDarker={Boolean(isDarker)} />
);
